























































































































































































































































































import { person, ParamsInfo, DataInfo } from '@/api/person'
import { department} from '@/api/department'
import { Component, Vue } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import Pagination from '@/components/Pagination/index.vue'
import { PersonType, PersonTypeTable } from '@/utils/enum/enum'
import { privateDecrypt } from 'crypto';
import { organization } from '../../api/organization';

@Component({
  components: {
    Pagination
  }
})
export default class Person extends Vue {
  private list: DataInfo[] = []
  private paramsInfo: ParamsInfo = {
    isSubscribe: '',
    name: '',
    position: 0,
    organizationId: this.$Cookies.get('organizationId'), // 组织的id
    pageNum: 1,
    pageSize: 10
  }

  private dataInfo: DataInfo = {
    id: 0,
    name: '',
    departments: [],
    position: '',
    departmentId: '',
    telephone: ''
  }

  private total: number = 0
  private dialogFormVisible: boolean = false
  private rules = {
    name: [{ required: true, message: '请输入姓名', trigger: 'change' }]
  }
  private batchData: any[] = []
  private searchField: string  = ''
  private selectType: number = 0
  private departmentData: any[] = []
  private smallSize: string = 'small'
  private miniSize: string = 'mini'
  private canEdit: boolean = false

  private personType = PersonType
  private personTypeTable = PersonTypeTable

  private createPersonDialog: boolean = false
  private wxNameContent: string = ''
  private createPersonData: [] = []
  private addPersonData: any = {}

  private created() {
    this.fetchData()
    this.queryTotal()
    this.queryInitData()
    if ( this.$Cookies.get('organizationId') === '4' || this.$Cookies.get('organizationId') === '1'
     || this.$Cookies.get('organizationId') === '10' || this.$Cookies.get('organizationId') === '') {
      let typeEnum = [
        { label: '保洁员', value: 11 },
        { label: '巡检员', value: 12 }
      ]
      this.personType = PersonType.concat(typeEnum)
      this.personTypeTable = PersonTypeTable.concat(typeEnum)
    }
  }

  // 查询数据
  private fetchData() {
    person('GET', this.paramsInfo, null, '/Page')
      .then((response: any) => {
        this.list = response
      })
      .catch(err => {
        console.log('catch' + err) // catch error
      })
  }

  private handleUpdate(row: any) {
    this.dialogFormVisible = true
    this.$nextTick(() => {
      (this.$refs.dataForm as ElForm).resetFields()
      this.dataInfo = Object.assign({}, row) // copy obj
      console.log(row)
      console.log(this.dataInfo)
    })
  }
  // 修改数据
  private updateData() {
    (this.$refs.dataForm as ElForm).validate((valid: any) => {
      if (valid) {
        const tempData = Object.assign({}, this.dataInfo);
        console.log(tempData)
        person('PUT', {
          organizationId: this.$Cookies.get('organizationId'),
          openId: tempData.openId,
          position: tempData.position,
          name: tempData.name,
          telephone: tempData.telephone
        }, tempData.departments, '/ByOpenId').then((response: any) => {
          this.fetchData()
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '更新成功',
            type: 'success',
            duration: 2000
          })
        })
      }
    })
  }

  // 复制：
  private copyOpenId(rowData: any) {
    // let openId: string = JSON.stringify(rowData.authUser.openid)
    let openId: string = rowData.authUser.openid
    const input = document.createElement('input');
    document.body.appendChild(input);
    input.setAttribute('value', openId);
    input.select();
    if (document.execCommand('copy')) {
      document.execCommand('copy');
      this.$message.success('复制成功')
    }
    document.body.removeChild(input);
  }

  // 处理删除
  private handleDetele(row: any, type: string) {
    this.$confirm(type === 'single' ? '此操作将永久删除该数据, 是否继续?' : '此操作将永久删除选中数据, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'error'
    })
      .then(() => {
        if (type === 'single') {
          this.singleDel(row)
        } else {
          this.allDel()
        }
      })
      .catch((err) => {
        console.log('catch' + err) // catch error
      })
  }

  // 单个删除
  private singleDel(row: any) {
    let deleteData: number[] = []
    deleteData.push(row.id)
    person('DELETE', null, deleteData).then((response: any) => {
      this.list.splice(this.list.indexOf(row), 1)
      this.$message({
        type: 'success',
        message: '删除成功!'
      })
      this.fetchData()
      this.queryTotal()
    })
  }

  // 全部删除
  private allDel() {
    let deleteData: number[] = []
    this.batchData.forEach(item => { deleteData.push(item.id) })
    person('DELETE', null, deleteData).then((response: any) => {
      deleteData.forEach(item => { this.list.splice(this.list.findIndex(model => model.id === item), 1) })
      this.$message({
        type: 'success',
        message: '删除成功!'
      })
      this.fetchData()
      this.queryTotal()
    })
  }

  private handleSelectionChange(val: any) {
    this.batchData = val
  }

  private handleSearch() {
    this.paramsInfo.name = this.searchField
    this.paramsInfo.position = this.selectType
    this.paramsInfo.pageNum = 1
    this.paramsInfo.pageSize = 10
    this.fetchData()
    this.queryTotal()
  }

  private queryTotal() {
    person('GET', this.paramsInfo, null, '/Count')
      .then((response: any) => {
        this.total = response
      })
      .catch(err => {
        console.log('catch' + err) // catch error
      })
  }

  private queryInitData() {
    department('GET', { organizationId: this.$Cookies.get('organizationId') }, null)
      .then((response: any) => {
        this.departmentData = response
      })
      .catch(err => {
        console.log('catch' + err) // catch error
    })
  }
  // 编辑表格数据+提交表格数据：
  private editAll() {
    this.canEdit = true
  }
  private exitEdit() {
    this.canEdit = false
    this.fetchData();
    this.queryTotal();
  }
  private submitData() {
    this.canEdit = false
    person('PUT', null, this.list, '/rangePerson')
    .then( (response: any) => {
      this.fetchData();
      this.queryTotal();
    })
  }

  // 添加人员：
  private handleCreate() {
    this.createPersonDialog = true
  }
  private async searchWxName() {
    const response: any = await person('GET', {
      nickName: this.wxNameContent,
      organizationId: this.$Cookies.get('organizationId')
    }, null, '/nickName')
    this.createPersonData = response
    if (response.length === 0) {
      this.$message.warning('暂无该微信号信息，请关注小梯同学公众号!')
      return
    }
    this.addPersonData = response[0]
  }
  private closeCreatePersonDialog() {
    this.createPersonDialog = false
    this.createPersonData = []
    // this.addPersonData = {}
  }
  private async createPersonDialogConfirm() {
    console.log(this.addPersonData)
    await person('PUT', {
          organizationId: this.$Cookies.get('organizationId'),
          openId: this.addPersonData.openId,
          position: this.addPersonData.position,
          name: this.addPersonData.name,
          telephone: this.addPersonData.telephone
        }, this.addPersonData.departments, '/ByOpenId')
    // let personId = this.addPersonData.id
    // const res = await person('PUT', null, this.addPersonData, `/${personId}`)
    this.$message.success('人员添加成功')
    this.createPersonDialog = false
    this.fetchData()
  }

  // 处理传过来的position数据：
  private transformValue(val: any) {
    let text: string = ''
    this.personTypeTable.forEach( (item, index) =>  {
      if (item.value === val) {
        text = item.label
      }
    })
    return text
  }

  // 状态筛选
  private filterStatusChange(filters: any) {
    this.paramsInfo.pageNum = 1
    this.paramsInfo.pageSize = 10
    this.paramsInfo.isSubscribe = filters.isSubscribe ? filters.isSubscribe[0] : ''
    this.fetchData()
    this.queryTotal()
  }
}
